export default class ImageCacheItem {
  public static readonly LOADING: string = "loading";
  public imageIndex: number = 0;
  public imageObjectUrl: string | null = ImageCacheItem.LOADING;
}
